export const SEND_SUPPORT_MESSAGE = 'SEND_SUPPORT_MESSAGE';
export const FETCH_SUPPORT_MESSAGES = 'FETCH_SUPPORT_MESSAGES';
